// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"371": "b965dacc3d7e","5015": "59cf926dd644","6212": "0f4bbf7cd766","9137": "ad7cf238c931",}[chunkId] + ".css"
}